var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        { name: "show", rawName: "v-show", value: _vm.show, expression: "show" }
      ],
      staticClass: "lite_popup lite_app_manage",
      on: {
        click: function($event) {
          $event.stopPropagation()
        }
      }
    },
    [
      _c("div", { staticClass: "lite_popup_box lite_app_manage_box" }, [
        _c("div", { staticClass: "lite_popup_title" }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("language.liteApp.title")))]),
          _vm._v(" "),
          _c("div", {
            staticClass: "icon white-close dialog-close",
            on: { click: _vm.close }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "lite_popup_content myscroll" },
          [
            !_vm.editing
              ? _c(
                  "div",
                  { staticClass: "lite_app_list" },
                  [
                    _c("div", { staticClass: "lite_app_toolbar" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("language.liteApp.description")))
                      ]),
                      _vm._v(" "),
                      _c("button", { on: { click: _vm.startCreate } }, [
                        _vm._v(_vm._s(_vm.$t("language.liteApp.addApp")))
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.loading
                      ? _c("div", { staticClass: "lite_app_loading" }, [
                          _vm._v(_vm._s(_vm.$t("language.common.load")))
                        ])
                      : _vm.apps.length === 0
                      ? _c("div", { staticClass: "lite_app_empty" }, [
                          _vm._v(_vm._s(_vm.$t("language.liteApp.empty")))
                        ])
                      : _vm._l(_vm.apps, function(app) {
                          return _c(
                            "div",
                            { key: app.id, staticClass: "lite_app_item" },
                            [
                              _c("div", { staticClass: "lite_app_item_name" }, [
                                _c("i", {
                                  staticClass: "lite_app_drive_icon",
                                  class: "drive-icon-" + app.type
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.cloudName(app.type)) +
                                      " · " +
                                      _vm._s(app.name)
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "lite_app_item_meta" }, [
                                _vm._v(_vm._s(app.key)),
                                app.inUse
                                  ? _c("span", [
                                      _vm._v(
                                        " · " +
                                          _vm._s(
                                            _vm.$t("language.liteApp.inUse")
                                          )
                                      )
                                    ])
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "lite_app_actions" }, [
                                _c(
                                  "button",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.startEdit(app)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("language.liteApp.edit"))
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    attrs: { disabled: app.inUse },
                                    on: {
                                      click: function($event) {
                                        return _vm.remove(app)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("language.common.delete"))
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        })
                  ],
                  2
                )
              : _c(
                  "el-form",
                  {
                    staticClass: "lite_app_form",
                    attrs: { model: _vm.draft, "label-width": "200px" }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("language.liteApp.appType") } },
                      [
                        _c(
                          "div",
                          { staticClass: "lite_app_type_select" },
                          [
                            _c("i", {
                              staticClass: "lite_app_drive_icon",
                              class: "drive-icon-" + _vm.draft.type
                            }),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                staticClass: "lite_app_select",
                                attrs: { disabled: !!_vm.draft.id },
                                model: {
                                  value: _vm.draft.type,
                                  callback: function($$v) {
                                    _vm.$set(_vm.draft, "type", $$v)
                                  },
                                  expression: "draft.type"
                                }
                              },
                              _vm._l(_vm.appTypes, function(type) {
                                return _c(
                                  "el-option",
                                  {
                                    key: type,
                                    attrs: {
                                      label: _vm.cloudName(type),
                                      value: type
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "lite_app_option" },
                                      [
                                        _c("i", {
                                          staticClass: "lite_app_drive_icon",
                                          class: "drive-icon-" + type
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(_vm.cloudName(type)))
                                        ])
                                      ]
                                    )
                                  ]
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("language.liteApp.appName") } },
                      [
                        _c("el-input", {
                          attrs: { maxlength: "255" },
                          model: {
                            value: _vm.draft.name,
                            callback: function($$v) {
                              _vm.$set(_vm.draft, "name", $$v)
                            },
                            expression: "draft.name"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("language.liteApp.clientId") } },
                      [
                        _c("el-input", {
                          attrs: { disabled: _vm.draft.inUse },
                          model: {
                            value: _vm.draft.key,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.draft,
                                "key",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "draft.key"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("language.liteApp.clientSecret")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            type: _vm.showSecret ? "text" : "password",
                            autocomplete: "new-password",
                            placeholder: _vm.draft.id
                              ? _vm.$t("language.liteApp.secretUnchanged")
                              : "",
                            disabled: _vm.draft.inUse
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "suffix",
                              fn: function() {
                                return [
                                  _c("div", {
                                    class: _vm.showSecret
                                      ? "open_eye"
                                      : "close_eye",
                                    on: {
                                      click: function($event) {
                                        _vm.showSecret = !_vm.showSecret
                                      }
                                    }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ]),
                          model: {
                            value: _vm.draft.secret,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.draft,
                                "secret",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "draft.secret"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.draft.callback
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("language.liteApp.callback")
                            }
                          },
                          [
                            _c(
                              "el-input",
                              {
                                staticClass: "lite_app_callback_input",
                                attrs: {
                                  value: _vm.draft.callback,
                                  readonly: ""
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "copy lite_app_copy_icon",
                                  attrs: {
                                    slot: "suffix",
                                    title: _vm.$t("language.common.copy")
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.copyCallback($event)
                                    }
                                  },
                                  slot: "suffix"
                                })
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.draft.inUse
                      ? _c("div", { staticClass: "lite_app_used_tip" }, [
                          _vm._v(_vm._s(_vm.$t("language.liteApp.usedTip")))
                        ])
                      : _vm._e()
                  ],
                  1
                )
          ],
          1
        ),
        _vm._v(" "),
        _vm.editing
          ? _c("div", { staticClass: "lite_popup_footer" }, [
              _c(
                "button",
                {
                  staticClass: "lite_app_cancel",
                  attrs: { disabled: _vm.saving },
                  on: { click: _vm.cancelEdit }
                },
                [_vm._v(_vm._s(_vm.$t("language.common.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                { attrs: { disabled: _vm.saving }, on: { click: _vm.save } },
                [_vm._v(_vm._s(_vm.$t("language.common.save")))]
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("liteConfirm", {
        ref: "deleteConfirm",
        attrs: {
          showCancel: true,
          autoClose: false,
          okText: _vm.$t("language.common.delete"),
          data: _vm.deleteConfirmData
        },
        on: { ok: _vm.confirmRemove }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6fbabf97", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fbabf97","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/personal_center_popups/lite_app_manage_popup.vue
// module id = null
// module chunks = 